export default __webpack_public_path__ + "images/logoPurlisse.0ca6a5e4f82ed3f709d9090180d16e90.svg"